// externals
import React from 'react';
import { MinusIcon, PlusIcon } from '@interstate/components/Icons';

// components
import {
    AccordionWrapper,
    AccordionHeader,
    HeaderLeft,
    PackageName,
    ToggleIcon,
    FeatureWrapper,
    FeatureChipGrid,
    FeatureChip
} from '../PackagesSection.style';

// types
import type { PackageAccordionItemProps } from '../../../types/InstalledOptionalEquipmentProps';

export const PackageAccordionItem: React.FC<PackageAccordionItemProps> = ({ optionalPackage, index, isOpen, onToggle }) => {
    // Packages without contents have nothing to reveal — no toggle icon and no pointer cursor.
    const hasContents = optionalPackage.contents.length > 0;

    return (
        <AccordionWrapper>
            <AccordionHeader data-testid={`package-${index}`} onClick={onToggle} aria-expanded={isOpen} $isExpandable={hasContents}>
                <HeaderLeft>
                    <PackageName size="small" weight="regular" forwardedAs="span">
                        {optionalPackage.name}
                    </PackageName>
                </HeaderLeft>
                {hasContents && (
                    <ToggleIcon $isOpen={isOpen} aria-hidden="true" data-testid={`package-${index}-toggle-icon`}>
                        {isOpen ? <MinusIcon /> : <PlusIcon />}
                    </ToggleIcon>
                )}
            </AccordionHeader>
            {isOpen && hasContents && (
                <FeatureWrapper>
                    <FeatureChipGrid>
                        {optionalPackage.contents.map((content, contentIndex) => (
                            <FeatureChip
                                key={contentIndex}
                                size="xsmall"
                                weight="regular"
                                forwardedAs="span"
                                data-testid={`package-${index}-feature-${contentIndex}`}
                            >
                                {content}
                            </FeatureChip>
                        ))}
                    </FeatureChipGrid>
                </FeatureWrapper>
            )}
        </AccordionWrapper>
    );
};
